<template>
    <div class="radio-wrapper form-group">
        <label v-if="label" class="input-label form-label">{{ label }}</label>

        <div class="radio-segment" :class="{ readonly: readonly }">
            <label 
                v-for="(option, index) in options" 
                :key="index"
                class="radio-option" 
                :class="{ active: internalValue === getOptionValue(option, index) }" 
                @click="!readonly && selectOption(getOptionValue(option, index))"
            >
                <input 
                    type="radio" 
                    :value="getOptionValue(option, index)" 
                    :checked="internalValue === getOptionValue(option, index)" 
                    :disabled="readonly"
                />
                <span class="dot"></span>
                {{ getOptionLabel(option) }}
            </label>
        </div>
    </div>
</template>
<script>
export default {
    name: "SegmentedRadio",
    props: {
        value: {
            type: String,
            default: "left"
        },
        options: {
            type: Array,
            default: () => ['Links', 'Rechts']
        },
        optionValues: {
            type: Array,
            default: null
        },
        label: {
            type: String,
            default: ""
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            internalValue: this.value || (this.options.length > 0 ? this.getOptionValue(this.options[0], 0) : "left")
        }
    },
    watch: {
        value(newVal) {
            if (newVal !== undefined && newVal !== null) {
                this.internalValue = newVal;
            }
        }
    },
    methods: {
        getOptionValue(option, index) {
            if (typeof option === 'object' && option.value) {
                return option.value;
            }
            if (this.optionValues && this.optionValues[index] !== undefined) {
                return this.optionValues[index];
            }
            const defaultValues = ['left', 'right', 'milling', 'printing'];
            return defaultValues[index] || `option${index}`;
        },
        getOptionLabel(option) {
            if (typeof option === 'object' && option.label) {
                return option.label;
            }
            return option;
        },
        selectOption(val) {
            this.internalValue = val;
            this.$emit('input', val);
        }
    }
}

</script>
<style lang="scss">
.radio-wrapper {
    color: #0a1724;
}

.radio-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    display: block;
    color: #0a1724;
}

.radio-segment {
    display: flex;
    background: rgba(10, 23, 36, 0.05);
    border: 1px solid rgba(10, 23, 36, 0.2);
    border-radius: 8px;
    overflow: hidden;
}

.radio-option {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    cursor: pointer;
    font-size: 16px;
    position: relative;
    transition: background 0.25s ease;
    margin: 0;
    color: #0a1724;
}

.radio-segment.readonly .radio-option {
    cursor: not-allowed;
    opacity: 0.6;
}

/* Divider */
.radio-option+.radio-option {
    border-left: 1px solid rgba(10, 23, 36, 0.2);
}

/* Hide native radio */
.radio-option input {
    display: none;
}

/* Circle */
.dot {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #0a1724;
    position: relative;
    border: 2px solid #0a1724;
}

.radio-option.active .dot {
    background: #0a1724;
    border-color: #0a1724;
}

.radio-option.active .dot::after {
    content: "";
    position: absolute;
    inset: 4px;
    background: #19AFB9;
    border-radius: 50%;
}

body.dark-layout {
    .radio-wrapper {
        color: #fff;
    }

    .radio-title {
        color: #fff;
    }

    .radio-segment {
        background: #FFFFFF14;
        border: 1px solid #FDFDFD26;
    }

    .radio-option {
        color: #fff;
    }

    .radio-option+.radio-option {
        border-left: 1px solid rgba(255, 255, 255, 0.15);
    }

    .dot {
        background: #fff;
        border-color: #fff;
    }

    .radio-option.active .dot {
        background: #fff;
        border-color: #fff;
    }
}

/* Active background */

</style>